(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');
    module.controller('TaskController', ['TaskStateEnum', function (TaskStateEnum) {
        /* jshint validthis:true */
        var vm = this;

        // finished task state
        vm.finishedTaskState = null;

        activate();

        /* init */
        function activate() {
            vm.finishedTaskState = TaskStateEnum.Finished;
        }
    }]);
})();
